/**
 * Prepares a guide document (a standalone HTML file imported raw) for display in the Guide tab's
 * `srcDoc` iframe. A srcdoc document has the URL `about:srcdoc` but resolves relative links against
 * the parent page's URL, so a plain `#section` anchor becomes `/info#section`, a different document,
 * and the frame navigates to the whole app instead of scrolling. The injected script keeps anchors
 * inside the frame and sends any other link to a new tab. The files on disk stay untouched and
 * keep working when opened directly.
 */
export const GUIDE_ANCHOR_SCRIPT_MARKER = "data-guide-anchors";

const SCRIPT = `<script ${GUIDE_ANCHOR_SCRIPT_MARKER}>
document.addEventListener("click", function (event) {
  var anchor = event.target && event.target.closest ? event.target.closest("a[href]") : null;
  if (!anchor) return;
  var href = anchor.getAttribute("href") || "";
  if (href.charAt(0) === "#") {
    event.preventDefault();
    var id = decodeURIComponent(href.slice(1));
    var target = id ? document.getElementById(id) : null;
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
    else if (!id) window.scrollTo({ top: 0, behavior: "smooth" });
  } else if (!anchor.getAttribute("target")) {
    anchor.setAttribute("target", "_blank");
    anchor.setAttribute("rel", "noopener");
  }
});
</script>`;

export function prepareGuideDocument(html: string): string {
  if (html.includes(GUIDE_ANCHOR_SCRIPT_MARKER)) return html;
  const bodyEnd = html.lastIndexOf("</body>");
  return bodyEnd === -1 ? html + SCRIPT : html.slice(0, bodyEnd) + SCRIPT + html.slice(bodyEnd);
}
